import { filters } from './filters-module';
import { main } from './main-module';

/**
 * @template S, R
 * @typedef {import('vuex').Module<S, R>} Module<S, R>
 */
/**
 * @typedef {import('@/store/root.state').RootState} RootState
 * @typedef {import('./projects.state').ProjectsState} ProjectsModules
 */

/** @type {Module<ProjectsModules, RootState>} */
export const projects = {
  namespaced: true,
  modules: {
    filters,
    main,
  },
};
